module.exports = __webpack_public_path__ + "img/login-art-2.1fdb8aa.jpg";